import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import MaterialTable, {MTableToolbar} from "material-table";

import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from '@mui/material/DialogContentText';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';

import Paper from "@material-ui/core/Paper";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Icon, IconButton, TableCell, TableRow, Tooltip } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {
  setStudentUnlocked,
  listenCourseActivity,
  setLock,
} from "../firebaseApi";
import { Typography } from "@material-ui/core";

const styles = (theme) => ({});

function InstructorLockoutMenu(props) {
  let mobile = props.width === "sm" || props.width === "xs";

  const [sessionObject, setSessionObject] = React.useState({});
  const [studentsData, setStudentsData] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [hideStudents, setHideStudents] = React.useState(true);
  const [searchActive, setSearchActive] = React.useState(false);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [totStudents, setTotStudents] = React.useState("0");
  const [unlockAllDialog, setUnlockAllDialog] = React.useState(false);

  const handleDelete = (studentEmail) => {
    console.log(studentEmail);
    setStudentsData((prevData) => prevData.filter((row) => row.email !== studentEmail));
  };

  React.useEffect(() => {
    if (props.open) {
      let data = {
        courseID: props.course.courseID,
      };
      let unsub = listenCourseActivity(data, (updatedCourse) => {
        try{
            setSessionObject(updatedCourse?.students);
        }catch(e){
            console.log(e);
        }
      });
      
      return () => {
        unsub();
      };
    }
  }, [props.open]);

  React.useEffect(() => {
    if (sessionObject && Object.keys(sessionObject).length > 0) {
      let studentsList = [];

      for (const [email, student] of Object.entries(sessionObject)) {
        
        if (student.locked == "1") {
          let studentData = {};
          // studentData["email"] = student.identifier;
          studentData["email"] = email;
          studentData["firstName"] = student.firstName;
          studentData["lastName"] = student.lastName;
          studentsList.push(studentData);
        }
      }
      setStudentsData(studentsList);
    }
  }, [sessionObject]);

  React.useEffect(() => {
    if (props.unlockStudent && props.selStudent !== "") {
      handleDelete(props.selStudent.email);
      props.setUnlockStudent(false);
    }
  }, [props.unlockStudent]);

  React.useEffect(() => {
    if (studentsData !== null) {
      setTotStudents(studentsData.length);
    }
  }, [studentsData]);

  return (
    <>
      {sessionObject && (
        <Dialog
          disableEscapeKeyDown
          fullScreen={mobile}
          fullWidth
          maxWidth="md"
          open={props.open}
          onClose={() => {
            props.openCtl(false);
          }}
        >
          <DialogTitle>
            {"Lockout Management for " +
              props.course.courseName}
          </DialogTitle>

          <DialogContent>
            <div style={{ display: "flex", alignItems: "center", flexDirection: "row" }}>
              <DialogContentText>Total students locked: {totStudents}</DialogContentText>
              <IconButton
                variant="outlined"
                color="primary"
                onClick={() => {
                  setDialogOpen(true);
                }}
              >
                <InfoOutlinedIcon />
              </IconButton>
            </div>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end" }}>
              <FormControl variant="standard">
                <Input
                  key="searchBar"
                  value={searchQuery}
                  onChange={(event)=> {
                    setSearchQuery(event.target.value);
                  }}
                  onKeyDown={(event)=>{
                    if (event.key === "Enter") {
                      setSearchActive(true);
                    } else {
                      setSearchActive(false);
                    }
                  }}
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <IconButton 
                      position="end"
                      onClick={()=>{
                        setSearchQuery("");
                        setSearchActive(false);
                      }}
                    >
                      <ClearIcon />
                    </IconButton> 
                  }
                />
              </FormControl>
              <Tooltip title={hideStudents ? "Students Hidden" : "Students Shown"}>
                <IconButton
                  onClick={()=>{
                    setHideStudents(!hideStudents);
                  }}
                >
                  {hideStudents ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                </IconButton>
              </Tooltip>
              <Tooltip title="Unlock All">
                <IconButton
                  onClick={() => {
                    setUnlockAllDialog(true);
                  }}
                >
                  <DeleteOutlinedIcon />
                </IconButton>
              </Tooltip>
            </div>
            <MaterialTable
              title=""
              columns={[
                { title: "Email", field: "email", sorting: false },
                { title: "First Name", field: "firstName", sorting: false },
                { title: "Last Name", field: "lastName", sorting: false },
              ]}
              data={studentsData === null ? [] : searchQuery === "" ? studentsData : studentsData.filter(student => student.firstName.toLowerCase().includes(searchQuery.toLowerCase()) || student.lastName.toLowerCase().includes(searchQuery.toLowerCase()) || student.email.toLowerCase().includes(searchQuery.toLowerCase()))}
              icons={{
                Clear: ClearOutlinedIcon,
              }}
              components={{
                Container: (props) => <Paper {...props} elevation={0} />,
              }}
              options={{
                showFirstLastPageButtons: false,
                paging: false,
                toolbar: false,
                showEmptyDataSourceMessage: searchActive || !hideStudents,
                rowStyle: {display: (searchActive || !hideStudents) ? "tableRow" : "none"},
              }}
              actions={[
                {
                  icon: AddCircleOutlineIcon,
                  tooltip: "Override",
                  onClick: (event, rowData) => {
                    // let data = {
                    //     sessionID: props.course.courseActivitySessionID,
                    //   accountID: rowData.email,
                    //   courseID: props.course.courseID,
                    //     locked:"0",
                    //     pollID: props.course.courseActivityPollID
                    // };
                    // setStudentUnlocked(data);
                    // handleDelete(rowData)
                    // props.setRerender();
                    let studentData = {
                      email: rowData.email,
                      firstName: rowData.firstName,
                      lastName: rowData.lastName,
                    }
                    console.log("opening popup");
                    console.log(studentData);
                    props.setSelStudent(studentData);
                    props.setOpenSelect(true);
                  },
                },
              ]}
            />
          </DialogContent>
          <Dialog
            open={dialogOpen}
            onClose={() => {
              setDialogOpen(false);
            }}
          >
            <DialogTitle>
              <Typography style={{ fontSize: "1.3rem" }} color="primary">
                How does Lockout Management work?
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                This page displays all students who voted in a lockout poll. 
                Until their accounts are unlocked, these students will have an "L" prepended to their votes and will recieve a notification stating that they need to contact the instructor before the end of the lecture. 
                When you select a student on this page, in addition to unlocking their account, you can also select the sessions for which you want to remove the prepended "L" from the student's votes.
                To protect student privacy, this page defaults to hiding all students until you search for them using the search bar; this feature can be toggled off and on by clicking on the eye icon next to the search bar.
              </Typography>
            </DialogContent>
            <Button
              style={{marginBottom: 10}}
              onClick={() => {
                setDialogOpen(false);
              }}
              color="primary"
            >
              Close
            </Button>
          </Dialog>
          <Dialog
            open={unlockAllDialog}
            onClose={() => {
              setUnlockAllDialog(false);
            }}
          >
            <DialogTitle>
              <Typography style={{ fontSize: "1.3rem" }} color="primary">
                Unlock All?
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Typography>
                You are about to unlock all student accounts and clear the sessions that each student voted in while their account was locked. 
                Please confirm that you wish to proceed.
              </Typography>
            </DialogContent>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginBottom: 10 }}>
              <Button
                style={{marginRight: 20}}
                onClick={() => {
                  if (Object.keys(sessionObject).length > 0) {
                      for (const email of Object.keys(sessionObject)) {
                        let data = {
                          sessionID: props.course.courseActivitySessionID,
                          accountID: email,
                          courseID: props.course.courseID,
                          locked:"0",
                          pollID: props.course.courseActivityPollID
                        };
                        setStudentUnlocked(data);
                        handleDelete(email);
                      }
                  }
                  setUnlockAllDialog(false);
                }}
                color="primary"
              >
                Confirm
              </Button>
              <Button
                style={{marginLeft: 20}}
                onClick={() => {
                  setUnlockAllDialog(false);
                }}
                color="primary"
              >
                Cancel
              </Button>
            </div>
          </Dialog>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                props.openCtl(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog> 
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(
      withWidth()(InstructorLockoutMenu)
    )
  )
);
